/*
 * Kadenze.NotificationList
 *
 * A notification list is responsible for containing a list of child view models and operating on that list
 *
 * @params: Object
 *   @title {String} - The title of the list, this is what sets the tab / window title
 *   @seeAllUrl {String} - Url where the "SEE ALL" link should go
 *   @items {Array} - Child items, each item in the array will be a list of Kadenze.NotificationListItem view models
 *   @count {Integer} - Count of all items in the list
 *   @freshCount {Integer} - Count of all 'fresh' items in the list
 *   @fadeTime {Integer} - time in milliseconds for fading out
*/

import NotificationListItem from './list-item';
import NotificationListConversation from './list-conversation';

export default function(params) {
  var self = this;

  self.defaults = {
    title: 'List Title',
    seeAllUrl: '#',
    items: [],
    count: 0,
    freshCount: 0,
    fadeTime: 500
  };

  self.config = _.extend({}, self.defaults, params);

  self.title = ko.observable(s.capitalize(self.config.title));
  self.seeAllUrl = ko.observable(self.config.seeAllUrl);
  self.calendarUrl = ko.observable(self.config.calendarUrl);
  self.messengerUrl = ko.observable(self.config.messengerUrl);
  self.count = ko.observable(self.config.count);
  self.freshCount = ko.observable(self.config.fresh_count);
  self.displayCalendar = ko.observable(self.config.displayCalendar);
  self.items = ko.observableArray();
  self.isActive = ko.observable(self.config.isFirst);
  self.hasSibling = ko.observable(self.config.hasSibling);
  self.loadedText = ko.observable('All ' + self.config.title + ' loaded...');
  self.loading = ko.observable(false);
  self.lastPage = ko.observable(false);
  self.calendarEventList = ko.observableArray();
  self.selectedCalendarEvents = ko.observable({});
  self.nextPage = 1;

  self.UUID = ko.computed(function() {
    return Kadenze.Util.UUID();
  });

  // If the list has another sibling list, this gives them a tabbed layout
  // within one window, i.e. calendar & updates
  self.headerClass = ko.computed(function() {
    var result;

    if(self.hasSibling()) {
      if(self.isActive()) {
        result = 'notification-center__tab notification-center__tab--active';
      } else {
        result = 'notification-center__tab';
      }
    } else {
      result = 'notification-center__header notification-center__header--active';
    }

    return result;
  });

  self.ariaSelected = ko.computed(function() {
    var result;

    if(self.hasSibling()) {
      if(self.isActive()) {
        result = 'true';
      } else {
        result = 'false';
      }
    } else {
      result = 'true';
    }
    return result;
  });

  // When there are not items in the list, this determines its' large background icon
  self.emptyIconClass = ko.computed(function() {
    return self.hasSibling() ? 'kdnze-notification-outline' : 'kdnze-messages-outline';
  });

  self.init = function() {
    self.addItems(self.config.items);
  };

  // Build a list of Kadenze.NotificationListItem view models
  self.addItems = function(items) {
    _.each(items, function(item) {
      if (self.config.title === 'conversations') {
        self.items.push(new NotificationListConversation(item));
      } else {
        self.items.push(new NotificationListItem(item));
      }
    });
  };


  // Removes an item from the 'self.items()' list, triggers the dismiss request
  // and re tallies the fresh items within the list
  self.removeItem = function(item, event) {
    event.stopPropagation();
    var $node = $('#' + item.UUID());
    $node.css('height', 0);
    TweenLite.to($node.parent(), self.config.fadeTime * 0.001, { height: 0, autoAlpha: 0 }).eventCallback('onComplete', function() {
      item._destroy();
      self.items.remove(item);
      self.sendDismissRequest(item);
      self.tallyFreshItems(self.items());
    });

  };

  // Send dismiss request for a single item
  self.sendDismissRequest = function(item) {
    new Kadenze.AjaxRequest({
      url: Kadenze.Routes.notification_path(item.data.id()),
      type: 'PATCH',
      data: { notification: { dismissed: true  } }
    });
  };

  // sends a batch update request for a list of items to update their 'freshness'
  self.sendBatchUpdateRequest = function(items) {
    var request,
      nonUpdatedItems = _.filter(items, function(item) { return !item.recentlyUpdated() && !item.data.fresh(); }),
      staleIds = _.map(nonUpdatedItems, function(item) { return item.data.id(); });

    if(nonUpdatedItems.length) {
      request = new Kadenze.AjaxRequest({
        url: Kadenze.Routes.batch_update_notifications_path(),
        type: 'PATCH',
        data: { ids: staleIds, type: self.config.title }
      });

      request.done(function() { self.refreshItems(staleIds); });
    }
  };

  // Tallies the child fresh items then triggers the parent view model to tally
  // all of its' child lists
  self.tallyFreshItems = function(items) {
    var freshItems = _.filter(items, function(item) {
      return item.data.fresh();
    });

    self.freshCount(freshItems.length);

    if(self.config.parentVM) {
      self.config.parentVM.tallyAllFreshItems();
    }
  };

  // Cycle through all child items and set their freshness and trigger the batch
  // update for those items
  self.updateFreshCount = function() {
    var updatedItems = _.map(self.items(), function(item, i) {
      if(item.data.fresh()) {
        item.data.fresh(false);
      }
      return item;
    });

    self.items(updatedItems);
    self.tallyFreshItems(self.items());
    self.sendBatchUpdateRequest(self.items());
  };

  // Cycle through all child items and set a flag so they don't get sent in a
  // batch update again once they've already been sent
  self.refreshItems = function(itemIds) {
    var refreshedItems = _.map(self.items(), function(item) {
      if(_.contains(itemIds, item.data.id())) {
        item.recentlyUpdated(true);
      }
      return item;
    });

    self.items(refreshedItems);
  };

  // Setup debounced scroll handler
  self.watchScroll = function() {
    var $el = $('#' + self.UUID()),
      debounced = _.debounce(self.scrollHandler, 300);

    $el.off('scroll.infinite').on('scroll.infinite', debounced);
  };

  // handle the scroll state of the list, if we're close to the bottom
  // load the next 'page' of notifications
  self.scrollHandler = function(event) {
    var $el = $(event.currentTarget),
      isAtBottom = ($el[0].scrollHeight - $el.scrollTop()) == $el.outerHeight();

    if(isAtBottom && !self.lastPage() && !self.loading()) {
      self.getNextPage();
    }
  };

  // Get next page of data
  self.getNextPage = function() {
    self.nextPage += 1;
    self.loading(true);

    var request = new Kadenze.AjaxRequest({
      url: Kadenze.Routes.grouped_notifications_path(),
      type: 'GET',
      dataAsJSON: false,
      data: { page: self.nextPage, category: self.config.title.toLowerCase()  }
    });

    request.done(self.addPaginatedItems);
  };

  // Handle adding returned paginated notifications
  self.addPaginatedItems = function(notifications) {
    self.loading(false);

    var items = notifications[self.config.title].items;

    if(items.length < 1) {
      return self.lastPage(true);
    }

    self.addItems(items);
  };

  self.init();

  return self;
}
